<template>
  <div>
    <div class="survey-question" flat @click="open">{{graph.name}}</div>
    <modal v-if="display" @close="display=false" @submit="save" btn="Save" :title="name">
      <h-input v-model="name" outline label="Graph Name"/>
      <button style="float:right" @click="destroy" type="button">Delete</button>
    </modal>
  </div>
</template>

<script>
import modal from "@/components/modal/default";
import snackbarHub from "@/services/hubs/snackbar";

export default {
  components: {
    modal
  },
  data() {
    return {
      display: false,
      name: "",
      saving: false
    };
  },
  props: ["graph"],
  methods: {
    open() {
      this.name = this.graph.name;
      this.display = true;
    },
    save() {
      this.saving = true;
      this.graph.name = this.name;
      this.graph
        .save()
        .then(() => {
          this.display = false;
          snackbarHub.update("Saved");
        })
        .finally(() => (this.saving = false));
    },
    destroy() {
      this.saving = true;
      this.graph
        .destroy()
        .then(() => {
          snackbarHub.update("Deleted");
          this.$emit("deleted", this.graph.id);
          this.display = false;
        })
        .finally(() => (this.saving = false));
    }
  }
};
</script>

<style>
</style>
